import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { CompanySubset } from 'app/api/company.api.service';
import { LoadingState } from 'app/utils/callstate';


import { CompaniesActions } from '../actions';
import { CompaniesState } from '../company.types';

export const adapter: EntityAdapter<CompanySubset> = createEntityAdapter<CompanySubset>({
    selectId: entry => entry.id
});

export const initialCompaniesState: CompaniesState = adapter.getInitialState({
    key: null,
    callState: LoadingState.Init,
});

export const reducer = createReducer(
    initialCompaniesState,
    on(
        CompaniesActions.companiesRequested,
        state => ({ ...state, callState: LoadingState.Loading })
    ),
    on(
        CompaniesActions.companiesLoaded,
        (state, { companies }): CompaniesState =>
            adapter.addAll(
                companies,
                {
                    ...state, callState: LoadingState.Loaded
                }
            )
    ),
    on(
        CompaniesActions.companiesCancelled,
        (state, { errorMessage }) => ({ ...state, callState: { errorMessage } })
    ),
);

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();
